import { HR_API_ENDPOINT } from "@config/consts";

import { AVAILABLE_COUNTRIES } from "@typings/globals";

import { getApiUrl } from "@services/ApiUrl/ApiUrl";
import { langFromPathname } from "@services/LangFromPathname";
import { defaultOptions as defaultFetchOptions } from "@services/FetchFacade";

import { IStore } from "@app/redux/reducers";

import {
  getForm,
  getAccessToken,
  getPersonalInfo,
  getExperienceInfo,
} from "./apply.selectors";
import { INFO_SOURCE } from "./apply.typings";

const asyncActionConfig = {
  apiEndpoint: getApiUrl("hr", "v1", HR_API_ENDPOINT),
  headers: {
    "Accept-Language": langFromPathname(),
  },
};

export const getAsyncActionHRConfig = () => asyncActionConfig;

export const getAsyncActionHRConfigSecure = (
  store: IStore,
  opts?: { contentType: string },
) => {
  const authorization: string[] = [];
  const accessToken = getAccessToken(store);
  const defaultAuthorization = defaultFetchOptions.headers?.Authorization;

  if (defaultAuthorization) {
    authorization.push(defaultAuthorization);
  }

  if (accessToken) {
    authorization.push(`Bearer ${accessToken}`);
  }

  return {
    ...asyncActionConfig,
    headers: {
      ...asyncActionConfig.headers,
      ...(authorization.length
        ? {
            Authorization: authorization.join(", "),
          }
        : {}),
      ...(opts && opts.contentType && { "Content-Type": opts.contentType }),
    },
  };
};

export const getSubmitEmailEndpointRequest = (store: IStore) => ({
  email: getForm(store).get("email"),
});

export const getSubmitPersonalInfoEndpointRequest = (store: IStore) => ({
  ...getPersonalInfo(store),
});

export const getSubmitExperienceInfoEndpointRequest = (
  store: IStore,
  country: AVAILABLE_COUNTRIES,
) => {
  const { workPermitType, howDidYouHearAboutUs, ...rest } =
    getExperienceInfo(store);

  const extraInfoSources = howDidYouHearAboutUs;
  if (howDidYouHearAboutUs.includes(INFO_SOURCE.FACEBOOK)) {
    extraInfoSources.push(INFO_SOURCE.GOOGLE, INFO_SOURCE.INSTAGRAM);
  }
  if (howDidYouHearAboutUs.includes(INFO_SOURCE.TV)) {
    extraInfoSources.push(INFO_SOURCE.RADIO);
  }

  const requireWorkPermit = country !== AVAILABLE_COUNTRIES.LU;
  const requireHowDidYouHearAboutUs = country === AVAILABLE_COUNTRIES.CH;

  return {
    ...rest,
    ...(requireHowDidYouHearAboutUs && {
      howDidYouHearAboutUs: extraInfoSources,
    }),
    ...(requireWorkPermit && {
      workPermitType,
    }),
  };
};
